import React from 'react';

const ErrorPage = ({ onLogout, errorMessage }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-cover bg-center h-screen"
      style={{ zIndex: 99999, background: 'var(--lh-auth-bg)' }}
    >
      <div className="bg-[#E81C1E] shadow-xl w-full max-w-sm mx-4 overflow-hidden z-10">
        <div className="bg-red-600 text-[#FFFFFF] px-6 py-4">
          <h2
            className="text-center text-lg font-normal"
            style={{
              fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '18px',
            }}
          >
            Access Denied
          </h2>
          <p
            className="text-center text-[#FFFFFF] mt-1 font-light"
            style={{
              fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '18px',
            }}
          >
            {errorMessage && 'Incorrect user type selected'}
          </p>
        </div>

        <div className="px-6 py-6 bg-white">
          <p
            className="text-center text-gray-800 text-sm mb-4"
            style={{ fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
          >
            Redirect to the <b>Account Type</b> Selection
          </p>
          <button
            onClick={onLogout}
            style={{ fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
            className="w-full bg-[#0F62FE] text-[#FFFFFF] py-2.5 px-4 text-sm font-normal hover:bg-blue-700 transition-colors"
          >
            Go to User Selection
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
